module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_completed-f776a97e8f703f6dba945d20b0992bba.svg";